import React from "react";
import './Footer.css';
import footer_logo from '../Assets/logo.png';
import Facebook_icon from '../Assets/facebook_icon.png';
import Telegram_icon from '../Assets/telegram_icon.png';
import youtube_icon from '../Assets/youtube.jpg';

const Footer = () => {
    return (
        <div className="footer">
		   {/* <div className="footer-logo">
                <img src={footer_logo} alt="Shopper Logo" /><br/>
                <hr/>
                
           </div>*/}
            {/*<p>Electrical & Computer Engineering Consultant</p>
            <ul className="footer-links">
                
                <li>
                    Service
                    <div className="tooltip">Explore our products</div>
                </li>
                
                <li>
                    About
                    <div className="tooltip">Know more about us</div>
                </li>
                <li>
                    Contact
                    <div className="tooltip">Get in touch</div>
                </li>
            </ul>*/}
            <div className="footer-social-icon">
                
                <div className="footer-icons-container">
                    <a
                        href="https://t.me/weynibirhan"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-label="@ወይኒብርሃን"
                    >
                        <img src={Telegram_icon} alt="Telegram" />
                    </a>
                </div>
                <div className="footer-icons-container">
                    <a
                        href="https://www.facebook.com/profile.php?id=61579591556078"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-label=""
                    >
                        <img src={Facebook_icon} alt="Facebook" />
                    </a>
                </div>
                <div className="footer-icons-container">
                    <a
                        href="https://www.youtube.com/@weynibirhan"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-label="@weynibirhan"
                    >
                        <img src={youtube_icon} alt="Youtube" />
                    </a>
                </div>
            </div>
            <div className="footer-copyright">
                <hr />
                <p>Copyright @2025 - all rights Reserved</p>
            </div>
        </div>
    );
}

export default Footer;
